import React from 'react'
import Logo from 'images/logo_rectangle_new.svg'
import { Link } from 'react-router-dom'

const HeaderLogo: React.FC = () => {
  return (
    <div id='logo'>
      <Link to='/' aria-label='home'>
        <img alt='logo' src={Logo} className={`xs:my-0 xs:mx-15`} />
      </Link>
    </div>
  )
}

export default HeaderLogo
